function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "m634a",
  d: "M821.75 647.04c0 40.284-45.555 72.94-101.75 72.94s-101.75-32.656-101.75-72.94S663.805 574.1 720 574.1s101.75 32.656 101.75 72.94z"
}), React.createElement("path", {
  id: "m634b",
  d: "M770.61 686.013h-64.054c.088-.916.118-1.861.118-2.807 0-19.06-15.54-34.573-34.632-34.573a34.45 34.45 0 0 0-19.24 5.85v-10.726H779.49v33.391c0 4.876-3.996 8.865-8.88 8.865zm-98.568 25.843c-15.836 0-28.712-12.857-28.712-28.67 0-15.813 12.876-28.67 28.712-28.67s28.712 12.857 28.712 28.67c0 15.813-12.876 28.67-28.712 28.67zm-10.36-107.705H770.61c4.884 0 8.88 3.99 8.88 8.867v5.912H652.802v-5.912c0-4.906 3.996-8.867 8.88-8.867zm-8.88 20.69H779.49v13.015H652.802zM770.61 598.24H661.682c-8.17 0-14.8 6.62-14.8 14.778v46.463c-5.86 6.207-9.472 14.542-9.472 23.734 0 19.064 15.54 34.582 34.632 34.582 16.073 0 29.63-10.995 33.507-25.862h65.061c8.17 0 14.8-6.621 14.8-14.779v-64.138c0-8.157-6.63-14.778-14.8-14.778z"
}), React.createElement("path", {
  id: "m634c",
  d: "M755.962 672.538a5.756 5.756 0 0 1-5.772-5.763 5.756 5.756 0 0 1 5.772-5.764c3.197 0 5.772 2.601 5.772 5.793 0 3.193-2.575 5.734-5.772 5.734zm-20.72 0a5.756 5.756 0 0 1-5.772-5.763 5.756 5.756 0 0 1 5.772-5.764c3.197 0 5.772 2.601 5.772 5.793 0 3.193-2.575 5.734-5.772 5.734zm20.72-17.438c-4.5 0-8.406 2.542-10.36 6.266a11.691 11.691 0 0 0-10.36-6.266c-6.453 0-11.692 5.232-11.692 11.675 0 6.443 5.24 11.675 11.692 11.675 4.5 0 8.406-2.542 10.36-6.266a11.691 11.691 0 0 0 10.36 6.266c6.453 0 11.692-5.232 11.692-11.675 0-6.443-5.24-11.675-11.692-11.675z"
}), React.createElement("path", {
  id: "m634d",
  d: "M681.07 673.995l-12.135 12.118-5.89-5.941c-1.155-1.153-3.02-1.182-4.174-.03-1.155 1.153-1.184 3.015-.03 4.168l7.992 8.04a2.96 2.96 0 0 0 2.102.886c.799 0 1.539-.325 2.101-.857l14.238-14.217a2.94 2.94 0 0 0 0-4.167c-1.184-1.153-3.049-1.153-4.203 0z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", {
  opacity: 0.7,
  transform: "rotate(-30 -630.572 1558.658)"
}, React.createElement("use", {
  fill: "#effff6",
  xlinkHref: "#m634a"
})), React.createElement("g", {
  transform: "translate(-637 -563)"
}, React.createElement("use", {
  fill: "#7d8998",
  xlinkHref: "#m634b"
})), React.createElement("g", {
  transform: "translate(-637 -563)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#m634c"
})), React.createElement("g", {
  transform: "translate(-637 -563)"
}, React.createElement("use", {
  fill: "#62ca31",
  xlinkHref: "#m634d"
})));

var SvgConfirmOrder = function SvgConfirmOrder(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 200,
    height: 177,
    viewBox: "0 0 200 177",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgConfirmOrder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirmOrder.4c769099.svg";
export { ForwardRef as ReactComponent };